import moment from "moment";
import Grid from '@mui/material/Grid2'
import { DayButton, DayLabel } from "./styled";

interface Props {
    isSelected?: boolean
    isDisabled?: boolean
    offset?: number
    onSelect: (value?: number) => void
    date: moment.Moment
}

export function Day(props: Props){
    const {
        date,
        onSelect,
        
        offset,


        isSelected,
        isDisabled
    } = props
    
    let sxOverride = {}
    if(isDisabled) sxOverride = {
        backgroundColor: '#f5f5f5',
        border: '1px solid #f5f5f5',
        color: '#d3d3d3',
        cursor: 'default',
        ':hover': {
            backgroundColor: '#f5f5f5',
        }
    }
    if(isSelected) sxOverride = {
        backgroundColor: '#ffc240',
        border: '1px solid #ffc240',
        ':hover': {
            border: '1px solid #407dff',
            backgroundColor: '#407dff',
            color: 'white'
        }
    }

    let onClick: (() => void) | undefined = () => onSelect(date.valueOf())
    if(isSelected) onClick = () => onSelect()
    if(isDisabled) onClick = undefined
    
    return (
        <DayButton
            sx={{
                ...sxOverride,
                gridColumn: offset,
                ml: 'auto'
            }}
            onClick={onClick}
        >
            <DayLabel>
                {date.format('DD')}
            </DayLabel>
        </DayButton>
    )
}